import React from 'react';

export { default as routes } from './routes';

export const WorkGroupDetailsPage = React.lazy(() => import('./pages/WorkGroupDetail'));

export { default as useWorkGroup } from './hooks/use-work-group';
export { default as useWorkGroups } from './hooks/use-work-groups';
